// extracted by mini-css-extract-plugin
module.exports = {"ComparisonBox":"ComparisonBox_ComparisonBox__snHfk"};